import { useTranslation } from 'react-i18next';
import { LocalizeNameSpaceTypes } from '@gov-nx/core/service';
import { pageRouteResolver } from '@gov-nx/web';
import { MarkdownRender } from '@gov-nx/component/web';

export const ComplainMessage = ({ typ }: { typ: 'FO' | 'PFO' }) => {
	const { t } = useTranslation([LocalizeNameSpaceTypes.Form]);

	const link = pageRouteResolver(typ === 'FO' ? 'profil.rob' : 'profil.ros');

	return (
		<MarkdownRender
			applyClasses={{
				paragraph: 'text-body-s!',
			}}>
			{t('complain.info-text', {
				link,
			})}
		</MarkdownRender>
	);
};
